import {Link} from "react-router-dom";
import {Routes} from "../utils";


export default function HomeScreen(props) {
  return (
    <div className="container" style={{maxWidth: 600}}>
      <div className="text-center">
        <h3>Witaj!</h3>
        <p className="mb-4">W kilku prostych krokach przygotujesz i sprawdzisz <br/>jak wygląda konfiguracja Twoich drzwi.</p>
        <Link to={Routes.configuration}>
          <span className="btn btn-primary">Przejdź dalej</span>
        </Link>
      </div>

    </div>
  )
}
